"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitialClientAddresses = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const AddressDTO_1 = require("../../shared/dto/AddressDTO");
class InitialClientAddresses {
}
exports.InitialClientAddresses = InitialClientAddresses;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => AddressDTO_1.AddressDTO),
    __metadata("design:type", AddressDTO_1.AddressDTO)
], InitialClientAddresses.prototype, "headQuarterAddress", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => AddressDTO_1.AddressDTO),
    __metadata("design:type", AddressDTO_1.AddressDTO)
], InitialClientAddresses.prototype, "invoiceAddress", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => AddressDTO_1.AddressDTO),
    __metadata("design:type", Array)
], InitialClientAddresses.prototype, "additionalAddresses", void 0);
